<div class="card card-custom h-100" style="background-color: white !important">
  <div class="card-header" style="min-height: fit-content; padding: 16.25px !important">
    <mat-form-field [formGroup]="search" class="w-100">
      <mat-label>Search</mat-label>
      <input type="text" matInput formControlName="searchInput" (keyup)="searchAction()" />
      <mat-icon matSuffix>search</mat-icon>
    </mat-form-field>
    <mat-form-field [formGroup]="filter" class="w-100">
      <mat-label>Filter By</mat-label>
      <mat-select
        #timelineFilter
        formControlName="timelineFilter"
        (selectionChange)="resetSent(); loadTimelines($event.value?.name)"
        [(value)]="timelineFilter.value"
      >
        <mat-select-trigger>
          <span
            *ngIf="timelineFilter.value?.img"
            [class]="'svg-icon m-1 svg-icon-' + timelineFilter.value?.color"
            [inlineSVG]="timelineFilter.value?.img"
          ></span>
          {{ timelineFilter.value?.label || timelineFilter.value?.name | titlecase }}
        </mat-select-trigger>
        <mat-option
          [value]="{
            img: 'assets/media/svg/icons/Communication/Group-chat.svg',
            name: 'CHAT',
            color: 'danger'
          }"
        >
          <span
            [class]="'svg-icon svg-icon-danger m-1'"
            [inlineSVG]="'assets/media/svg/icons/Communication/Group-chat.svg'"
          ></span>
          Chat
        </mat-option>
        <mat-option
          [value]="{
            img: 'assets/media/svg/icons/Communication/Incoming-mail.svg',
            name: 'EMAIL',
            color: 'primary'
          }"
        >
          <span
            [class]="'svg-icon svg-icon-primary m-1'"
            [inlineSVG]="'assets/media/svg/icons/Communication/Incoming-mail.svg'"
          ></span>
          Email
        </mat-option>
        <mat-option
          [value]="{
            img: 'assets/media/svg/icons/Communication/Incoming-box.svg',
            name: 'FAX',
            color: 'success'
          }"
        >
          <span
            [class]="'svg-icon svg-icon-success m-1'"
            [inlineSVG]="'assets/media/svg/icons/Communication/Incoming-box.svg'"
          ></span>
          Fax
        </mat-option>
        <mat-option
          [value]="{
            img: 'assets/media/svg/icons/Code/Time-schedule.svg',
            name: 'MEETING',
            color: 'warning'
          }"
        >
          <span
            [class]="'svg-icon svg-icon-warning m-1'"
            [inlineSVG]="'assets/media/svg/icons/Code/Time-schedule.svg'"
          ></span>
          Meeting
        </mat-option>
        <mat-option
          [value]="{
            img: 'assets/media/svg/icons/General/focus-svgrepo-com.svg',
            name: 'FILTERED_VIEW_SESSION',
            label: 'SESSION',
            color: 'secondary'
          }"
        >
          <span
            [class]="'svg-icon svg-icon-secondary m-1'"
            [inlineSVG]="'assets/media/svg/icons/General/focus-svgrepo-com.svg'"
          ></span>
          Session
        </mat-option>
        <mat-option
          [value]="{
            img: 'assets/media/svg/icons/Code/Warning-2.svg',
            name: 'ALERT',
            label: 'ALERT',
            color: 'info'
          }"
        >
          <span
            [class]="'svg-icon svg-icon-info m-1'"
            [inlineSVG]="'assets/media/svg/icons/Code/Warning-2.svg'"
          ></span>
          Alert
        </mat-option>
        <mat-option
          [value]="{
            img: 'assets/media/svg/icons/General/notification2.svg',
            name: 'NOTIFICATION',
            label: 'NOTIFICATION',
            color: 'info'
          }"
        >
          <span
            [class]="'svg-icon svg-icon-info m-1'"
            [inlineSVG]="'assets/media/svg/icons/General/notification2.svg'"
          ></span>
          Notification
        </mat-option>
        <mat-option [value]="{ img: '', name: '', label: 'All' }">All</mat-option>
      </mat-select>
    </mat-form-field>
    <mat-checkbox
      [(ngModel)]="showReviews"
      *ngIf="
        timelineFilter.value?.name === '' || timelineFilter.value?.name === 'FILTERED_VIEW_SESSION'
      "
      (change)="resetSent(); loadTimelines(timelineFilter.value?.name)"
      class="font-size-xs"
      style="margin-right: 15px"
    >
      Show Review & Non-Contact Sessions
    </mat-checkbox>
  </div>
  <!-- end::Header -->

  <div
    style="overflow-y: auto; padding: 16.25px !important"
    class="card-body my-5 scroll"
    [perfectScrollbar]="{ wheelPropagation: false }"
  >
    <div *ngIf="spinnerStateSent" class="d-flex justify-content-center text-primary mt-5">
      <div class="spinner-grow" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>
    <div
      class="mat-table-message mt-5"
      style="text-align: center"
      *ngIf="timelines.length === 0 && !spinnerStateSent"
      translate="GLOBAL.NO_RECORDS_FOUND"
    >
      No Records Found
    </div>
    <div *ngIf="!spinnerStateSent" class="timeline timeline-4">
      <div class="timeline-bar"></div>
      <div class="timeline-items">
        <ng-container *ngFor="let item of timelines">
          <ng-container
            [ngTemplateOutlet]="itemTemplate"
            [ngTemplateOutletContext]="{ item: item }"
          ></ng-container>
        </ng-container>
      </div>
    </div>
  </div>
</div>

<ng-template #itemTemplate let-item="item">
  <div [class]="getItemClass(item)">
    <div class="timeline-badge">
      <span [class]="getItemColor(item.type)" [inlineSVG]="getItem(item.type)"></span>
    </div>
    <div class="timeline-content">
      <div class="">
        <div class="text-muted mb-2" style="font-size: 10px !important; text-align: end">
          {{ getDate(item.created) }}
        </div>
        <span
          class="label label-secondary font-weight-bolder label-inline mb-1"
          matTooltip="Type"
          >{{ getRealType(item.type) }}</span
        >
        <span
          class="label label-light-primary font-weight-bolder label-inline ml-2"
          *ngFor="let app of item.application_id"
          matTooltip="App"
          >{{ getApplicationName(app) }}</span
        >
        <p class="p-0 mb-1 mt-1 font-weight-bolder" *ngIf="item.sender_name" matTooltip="Sender">
          <{{ (item.sender_name ? item.sender_name : '') | slice : 0 : 150 }}>
        </p>
        <a class="dark-75 font-weight-bold text-capitalize d-block"> {{ item.subject }} </a>
      </div>
      <p class="p-0 pl-1" [innerHTML]="item.body || '' | slice : 0 : 150 | safe : 'html'"></p>
      <p
        class="p-0 pl-1"
        *ngIf="item.note"
        [innerHTML]="item.note || '' | slice : 0 : 150 | safe : 'html'"
      ></p>
      <div class="d-flex justify-content-end">
        <a
          (click)="readMore(item, item.type)"
          class="btn btn-sm btn-light-primary btn-text-primary btn-hover-text font-weight-bold btn-pill"
          aria-expanded="false"
        >
          <span class="svg-icon">Read More</span>
        </a>
      </div>
    </div>
  </div>
</ng-template>
